<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">
        <el-container class="SiteManagement" :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>场地管理</h2>
                    </el-col>
                    <el-col :span="12"></el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddSite">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" :height="Height - 265" border style="width: 100%">
                    <el-table-column prop="title" label="场地标题" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="type" label="场地类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type === 1">会议室</span>
                            <span v-if="scope.row.type === 2">直播间</span>
                            <span v-if="scope.row.type === 3">路演厅</span>
                            <span v-if="scope.row.type === 4">办公室</span>
                            <span v-if="scope.row.type === 5">办公空间</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="people" label="场地容纳人数">
                    </el-table-column>
                    <el-table-column prop="status" label="场地状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 0">未开放</span>
                            <span v-if="scope.row.status === 1">开放</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="场地单价" align="right">
                    </el-table-column>
                    <el-table-column prop="timeS" label="开始开放时间">
                    </el-table-column>
                    <el-table-column prop="timeE" label="结束开放时间">
                    </el-table-column>
                    <el-table-column prop="device" label="场地设备配置" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="address" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="EditSite(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="DeleteSite(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Site" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Site">
                    <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="场地标题" prop="title">
                           <el-input v-model="formData.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="场地类型" prop="type">
                           <el-select v-model="formData.type" placeholder="请选择">
                                <el-option v-for="item in TypeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="场地容纳人数" prop="people">
                           <el-input v-model="formData.people" placeholder="请输入容纳人数"></el-input>
                        </el-form-item>
                        <el-form-item label="场地状态" prop="status">
                           <el-select v-model="formData.status" placeholder="请选择">
                                <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="场地单价" prop="price">
                            <el-input v-model="formData.price" placeholder="请输入单价"></el-input>
                        </el-form-item>
                        <el-form-item label="场地开放时间" v-if="formData.status === 1 && formData.type !== 3">
                           <!-- <el-input v-model="formData.time" placeholder="请输入容纳人数"></el-input> -->
                           <!-- <el-time-picker
                                is-range
                                :picker-options="{
                                    step: '00:30'
                                }"
                                arrow-control
                                v-model="formData.time"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围"
                                value-format="HH:mm" @change="change">
                            </el-time-picker> -->
                            <el-time-select
                                style="display: inline-block; width: calc(50% - 30px);"
                                v-model="formData.timeS"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '23:30'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                            <span style="display: inline-block; width: 60px; text-align: center;">至</span>
                            <el-time-select
                                style="display: inline-block; width: calc(50% - 30px);"
                                v-model="formData.timeE"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '23:30'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item label="设备配置">
                           <el-input type="textarea" v-model="formData.device" placeholder="请输入设备配置"></el-input>
                        </el-form-item>
                        <el-form-item label="备注介绍">
                           <el-input type="textarea" v-model="formData.remark" placeholder="请输入备注"></el-input>
                        </el-form-item>
                        <el-form-item label="场地图片视频">
                           <!-- <el-input v-model="formData.imgs" placeholder="请输入容纳人数"></el-input> -->
                           <el-upload
                                class="upload-demo"
                                :action="http + '/Spaceorder/upload_file'"
                                :data="Uploaddata"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :on-success="SiteUploadSuccess"
                                :before-upload="SiteBeforeUpload"
                                multiple
                                :limit="5"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirm" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="预览" :visible.sync="preview" width="800px">
                    <img v-if="type === 1" :src="urls + url">
                    <video v-if="type === 2" :src="urls + url"></video>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
/*eslint-disable */
export default {
    name: "SiteManagement",
    data() {
        return {
            urls: https.http,
            fileList: [],
            tableData: [],
            currentPage: 1,
            Size: 20,
            total: 1,
            Site: false,
            title: '',
            formData: {
                title: '',
                type: 1,
                device: '',
                people: '',
                remark: '',
                time: ['07:00:00', '23:59:59'],
                timeS: '07:00',
                timeE: '23:30',
                status: 0,
                imgs: [],
                price: ''
            },
            TypeList: [{
                label: '会议室',
                value: 1
            }, {
                label: '直播间',
                value: 2
            }, {
                label: '路演厅',
                value: 3
            }, {
                label: '办公室',
                value: 4
            }, {
                label: '办公空间',
                value: 5
            }],
            StatusList: [{
                label: '未开放',
                value: 0
            }, {
                label: '开放',
                value: 1
            }],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            rules: {
                title: [
                    { required: true, message: '请输入场地标题', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择场地类型', trigger: 'blur' }
                ],
                people: [
                    { required: true, message: '请输入场地容纳人数', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择场地状态', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入场地单价', trigger: 'blur' }
                ]
            },
            http: https.https,
            preview: false,
            type: 1,
            url: '',
            confirmloding: false,
            fullscreenLoading: false
        };
    },
    mounted() {},
    watch: {},
    methods: {
        change (val) {
            console.log(val)
        },
        handleClick() {
        },
        handleSizeChange(size) {
            this.Size = size
            this.GetSiteManagementList()
        },
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.GetSiteManagementList()
        },
        GetSiteManagementList() {
            this.fullscreenLoading = true
            let data = {
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('GetSiteManagementListShow', data).then(res => {
                this.tableData = res.data
                this.fullscreenLoading = false
                this.total = res.something
            })
        },
        cancel() {
            this.formData = {
                title: '',
                type: 1,
                device: '',
                people: '',
                remark: '',
                time: ['07:00:00', '23:59:59'],
                timeS: '',
                timeE: '',
                status: 0,
                imgs: [],
                price: ''
            }
            this.fileList = []
            this.Site = false
        },
        confirm() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.formData))
            // data.timeS = data.time[0]
            // data.timeE = data.time[1]
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    data.ADMIN_ID = getAdminId()
                    data.ADMIN_TOKEN = getToken()
                    data.imgs = JSON.stringify(data.imgs)
                    that.confirmloding = true
                    that.$store.dispatch('SaveSiteManagement', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.formData = {
                                title: '',
                                type: 1,
                                device: '',
                                people: '',
                                remark: '',
                                time: ['07:00:00', '23:59:59'],
                                timeS: '',
                                timeE: '',
                                status: 0,
                                imgs: [],
                                price: ''
                            }
                            that.fileList = []
                            that.GetSiteManagementList()
                            that.Site = false
                        } else {
                            that.confirmloding = false
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        AddSite() {
            this.title = '新增场地'
            this.Site = true
        },
        handlePreview(file) {
            console.log(file)
            let str = file.response.split('.').pop()
            if (str === 'image/jpeg' || str === 'image/png') {
                this.type = 1
            } else if (str === 'mp4' || str === 'mov' || str === 'm4v' || str === '3gp' || str === 'avi' || str === 'm3u8' || str === 'webm') {
                this.type = 2
            }
            this.url = file.response
            this.preview = true
        },
        handleRemove(file, fileList) {
            this.formData.imgs = fileList
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        SiteBeforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            let arr = file.name.split('.')
            let str = arr.pop()
            const isvideo = str === 'mp4' || str === 'mov' || str === 'm4v' || str === '3gp' || str === 'avi' || str === 'm3u8' || str === 'webm'
            if (!isJPG&&!isvideo) {
                this.$message.error('只能上传图片和视频！');
            }
            return isJPG||isvideo;
        },
        SiteUploadSuccess(response, file, fileList) {
            this.formData.imgs = fileList
        },
        EditSite(row) {
            this.title = '编辑场地'
            this.formData = JSON.parse(JSON.stringify(row))
            // this.formData.time = ['07:00:00', '23:59:59']
            this.$set(this.formData, "time", ['07:00:00', '23:59:59'])
            this.formData.time[0] = this.formData.timeS
            this.formData.time[1] = this.formData.timeE
            // console.log(JSON.parse(this.formData.imgs))
            this.fileList = JSON.parse(this.formData.imgs)
            this.formData.imgs = JSON.parse(this.formData.imgs)
            this.Site = true
        },
        DeleteSite(row) {
            this.$confirm('是否删除该场地？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true
                row.ADMIN_ID = getAdminId()
                row.ADMIN_TOKEN = getToken()
                this.$store.dispatch('DeleteSite', row).then(res => {
                    if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.GetSiteManagementList()
                    } else {
                        this.fullscreenLoading = false
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {       
            });
        }
    },
    created() {
        // 预约管理列表
        this.GetSiteManagementList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
};
</script>

<style>
.SiteManagement {
    width: 100%;
}
.SiteManagement .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.SiteManagement .el-header .el-row .el-col h2 {
    text-align: center;
}
.SiteManagement .el-header .el-row .el-col {
    text-align: center;
}
.SiteManagement .el-header .el-row .el-col:last-child {
    text-align: right;
}
.SiteManagement .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SiteManagement .el-main .Site .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
    height: 60vh;
    overflow: auto;
}
.SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item {
    display: inline-block;
    width: 100%;
}
.SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item .el-select,.SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item .el-date-editor {
    width: 100%;
}
.SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item:nth-child(2), .SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item:nth-child(3),.SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item:nth-child(4), .SiteManagement .el-main .Site .el-dialog__body .el-form .el-form-item:nth-child(5) {
    width: 50%;
}

</style>
